<template>
  <div class="building-manage" :class="{'app-region blank-t-v blank-l-h blank-r-h': !communityId}">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>楼栋名称</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入楼栋名称" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="newBuilding()">新增楼栋</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="editBuilding(data)">编辑</a-button>
          <a-button type="link" @click="scanBuilding(data)">查看</a-button>
          <a-button type="link" @click="copyBuilding(data)">复制</a-button>
          <a-button type="link" @click="deleteBuilding(data)">删除</a-button>
        </a-space>
      </template>
    </a-table>
    <a-drawer width="80%" :title="drawer.title" :visible="drawer.show" destroy-on-close @close="drawer.show = false">
      <building-info :init-id="drawer.id" is-scan></building-info>
    </a-drawer>
  </div>
</template>

<script>
  import BuildingService from '@/io/building.js';
  import BuildingInfo from '@/views/community/BuildingInfo.vue';

  export default {
    name: 'BuildingManage',
    props: {
      communityId: {
        type: Number,
        default: null
      },
    },
    data() {
      let self = this;
      return {
        table: {
          loading: false,
          search: {
            name: null,
            area: null,
            status: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '楼栋名称',
              dataIndex: 'alias'
            },
            {
              title: '单元数',
              dataIndex: 'door_num'
            },
            {
              title: '房屋数',
              dataIndex: 'house_num'
            },
            {
              title: '住户数',
              dataIndex: 'owner_num'
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        drawer: {
          id: null,
          title: '楼栋详情',
          show: false
        }
      }
    },
    watch: {
      communityId: {
        handler(newValue, oldValue) {
          if (newValue || this.$getCookie('communityId')) {
            this.searchTable();
          }
        },
        immediate: true
      }
    },
    components: {
      BuildingInfo,
    },
    activated() {
      if (this.communityId) {
        this.initData();
      }
    },
    methods: {
      copyBuilding(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认复制此楼栋？',
          onOk() {
            BuildingService.copy(data.id).then(res => {
              self.initData();
            }).catch(err => {});
          }
        });
      },
      newBuilding() {
        this.table.page.current = 1;
        this.toPage({
          name: 'NewBuilding'
        });
      },
      editBuilding(data) {
        this.toPage({
          name: 'EditBuilding',
          params: {
            id: data.id
          }
        });
      },
      scanBuilding(data) {
        this.drawer.id = data.id;
        this.drawer.show = true;
      },
      deleteBuilding(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认删除此楼栋？',
          onOk:()=> {
            BuildingService.del(data.id, this.communityId).then(res => {
              self.initData();
            }).catch(err => {});
          }
        });
      },
      toPage(params) {
        if (this.communityId) {
          params = {
            ...params,
            query: {
              community_id:  this.communityId
            }
          }
        }
        this.$router.push(params);
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          name: null
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        this.$emit('total', 0);
        BuildingService.listPage(
          this.communityId,
          this.table.search.name,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
          this.$emit('total', res.meta.pagination.total);
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>